import { createBrowserClient } from "@supabase/ssr";
import { Database } from "@/types/database";
import { clientLogger } from "@oxpa/shared/lib/logger/client";
import { createLddFetchInterceptor } from "./ldd-fetch-interceptor";

const customFetch = createLddFetchInterceptor(clientLogger, "Supabase Client");

export function createClient() {
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      global: {
        fetch: customFetch,
      },
    }
  );
}

